import styles from "./EmptyState.module.css";

type EmptyStateProps = {
  icon: () => JSX.Element;
  title: string;
  description: string;
};

const EmptyState = ({ icon: Icon, title, description }: EmptyStateProps) => {
  return (
    <div className={styles.wrapper}>
      <span className={styles.icon}>
        <Icon />
      </span>
      <span className={styles.title}>{title}</span>
      <span className={styles.description}>{description}</span>
    </div>
  );
};

export default EmptyState;
